module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("h55DY"))).then(() => parcelRequire('d0iPb'));